import { Filters } from 'context/FilterProvider/types/Filters';

export const defaultFilters: Filters = {
  environment: [],
  publisher: [],
  formatSize: [],
  status: [],
  resolution: [],
  frameId: [],
};
